import React, { FC, useMemo, useRef, useState } from 'react';

import DataGrid, { Column, Pager, Paging } from 'devextreme-react/data-grid';

import { AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { Button } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { AddEditModal, DeleteModal } from './components';

type Props = {
  transportId: number;
};

const DriverTransport: FC<Props> = ({ transportId }) => {
  const driverTransport: any = useMemo(() => {
    return $createStore(`/v1/DriverTransport/${transportId}/driverConfigurations`, 'driverId');
  }, [transportId]);

  const [visible, setVisible] = useState<boolean>(false);

  const [visibleDelete, setVisibleDelete] = useState<boolean>(false);
  const [openIdDelete, setOpenIdDelete] = useState<number | null>(null);

  const refGrid = useRef<DataGrid | null>(null);

  const openAddEditModalHandler = () => setVisible(true);
  const closeAddEditModalHandler = () => setVisible(false);

  const refreshGrid = () => refGrid.current?.instance.refresh();

  return (
    <div>
      <div className="pr-2 pt-2">
        <AppLayoutTop title="">
          <ClaimsProvider claimsBlock={['CanCreateTransport']}>
            <Button width={120} text="Добавить" type="default" onClick={openAddEditModalHandler} />
          </ClaimsProvider>
        </AppLayoutTop>

        {visible && (
          <AddEditModal
            visible={visible}
            onClose={closeAddEditModalHandler}
            transportId={transportId}
            refresh={refreshGrid}
          />
        )}
        <DeleteModal
          changeVisible={setVisibleDelete}
          transportId={transportId!}
          driverId={openIdDelete!}
          refresh={refreshGrid}
          visible={visibleDelete}
        />

        <DataGrid
          dataSource={driverTransport}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations
        >
          <Column dataField="driverName" caption="ФИО" />
          <Column
            dataField="actions"
            caption=""
            width={150}
            cellRender={(data) => (
              <ClaimsProvider claimsBlock={['CanDeleteTransport']}>
                <div>
                  <Button
                    icon="trash"
                    type="normal"
                    stylingMode="text"
                    onClick={() => {
                      setOpenIdDelete(data.key);
                      setVisibleDelete(true);
                    }}
                  />
                </div>
              </ClaimsProvider>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </div>
    </div>
  );
};

export default DriverTransport;
